"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Expandable = void 0;

var _react = _interopRequireWildcard(require("react"));

var _isText = require("../../helpers/isText");

var _svgs = require("../../svgs");

var _Theme = require("../../Theme");

var _Box = require("../Box");

var _Clickable = require("../Clickable");

var _Flex = require("../Flex");

var _Text = require("../Text");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A toggleable component used to show / hide content
 */
var Expandable = function Expandable(_ref) {
  var label = _ref.label,
      defaultExpanded = _ref.expanded,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["label", "expanded", "children", "disabled", "onClick"]);

  var tokens = (0, _Theme.useThemeConfig)({
    v2: {
      borderColor: "black10",
      textProps: {
        variant: "small",
        fontWeight: "bold"
      },
      chevronSize: 12,
      mr: undefined
    },
    v3: {
      borderColor: "black60",
      textProps: {
        variant: "md"
      },
      chevronSize: 14,
      mr: 1
    }
  });

  var _useState = (0, _react.useState)(defaultExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _splitBoxProps = (0, _Box.splitBoxProps)(rest),
      _splitBoxProps2 = _slicedToArray(_splitBoxProps, 2),
      boxProps = _splitBoxProps2[0],
      clickableProps = _splitBoxProps2[1];

  var handleClick = function handleClick(event) {
    setExpanded(function (prevExpanded) {
      return !prevExpanded;
    });
    onClick && onClick(event);
  };

  return /*#__PURE__*/_react.default.createElement(_Box.Box, boxProps, /*#__PURE__*/_react.default.createElement(_Clickable.Clickable, _extends({
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderTop: "1px solid",
    borderColor: tokens.borderColor,
    pt: 1,
    disabled: disabled,
    "aria-expanded": expanded,
    onClick: handleClick
  }, clickableProps), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flex: 1,
    minHeight: 40,
    display: "flex",
    alignItems: "center"
  }, (0, _isText.isText)(label) ? /*#__PURE__*/_react.default.createElement(_Text.Text, tokens.textProps, label) : label), !disabled && /*#__PURE__*/_react.default.createElement(_svgs.ChevronIcon, {
    direction: expanded ? "up" : "down",
    width: tokens.chevronSize,
    height: tokens.chevronSize,
    ml: 1,
    mr: tokens.mr,
    "aria-hidden": "true"
  })), expanded && children);
};

exports.Expandable = Expandable;
Expandable.displayName = "Expandable";
//# sourceMappingURL=Expandable.js.map